module.exports = __webpack_public_path__ + "img/ever-logo.d3d92e34.svg";